import { REGIONS } from './region';
const GENERIC_REGION = REGIONS.us;
const NON_REGION_PREFIXES = ['reverse', 'staging', 'local', 'tour', 'members', 'musclecharge'];
function hasRegionPrefix(hostname) {
    const [firstSegment] = hostname.split('.');
    return NON_REGION_PREFIXES.every((prefix) => !firstSegment.includes(prefix));
}
export function getRegionFromHostname(hostname) {
    const normalizedHostname = hostname?.toLowerCase() || '';
    if (normalizedHostname.includes('herokuapp.com') || !normalizedHostname.length) {
        return GENERIC_REGION;
    }
    if (hasRegionPrefix(normalizedHostname)) {
        const [region] = normalizedHostname.split('.');
        const regionUpper = region.toUpperCase();
        if (Object.values(REGIONS).includes(regionUpper)) {
            return regionUpper;
        }
    }
    return GENERIC_REGION;
}
